export default {
  "hero.badge": "Recurso independiente • Actualizado regularmente • Multilingüe",
  "hero.title": "USFans Spreadsheet — Encuentra productos, compara y compra de forma más inteligente",
  "hero.subtitle":
    "Explora el Spreadsheet de USFans, descubre productos por categoría, compara la información disponible, infórmate sobre control de calidad, envío y consejos de compra, y toma mejores decisiones.",
  "hero.trust": "Enfocado en seguridad • Información de QC • Guías de envío",

  "intro.title": "¿Qué es el Spreadsheet de USFans?",
  "intro.p1":
    "El Spreadsheet de USFans es un catálogo de productos compartido que ayuda a descubrir, explorar y comparar artículos de muchas categorías — desde zapatos y ropa hasta bolsos y accesorios.",
  "intro.p2":
    "En lugar de buscar en listas interminables, puedes ir directo a una categoría, revisar lo disponible y seguir los enlaces para saber más en el sitio principal.",

  "categories.title": "Explora los productos de USFans por categoría",
  "categories.subtitle":
    "Elige una categoría para explorar lo disponible. Cada enlace abre la sección correspondiente en el sitio principal de USFans.",

  "how.title": "Cómo funciona el Spreadsheet",
  "how.step1.title": "Elige una categoría",
  "how.step1.text": "Selecciona una categoría en el menú desplegable o en las tarjetas.",
  "how.step2.title": "Compara productos",
  "how.step2.text": "Revisa la información disponible y compara lo que se ajusta a tus necesidades.",
  "how.step3.title": "Verifica QC y envío",
  "how.step3.text": "Lee nuestras notas de control de calidad y envío para saber qué esperar.",
  "how.step4.title": "Continúa al sitio principal",
  "how.step4.text": "Sigue el enlace al sitio principal para ver los detalles y completar tu pedido.",

  "guide.title": "Lee nuestra guía completa",
  "guide.subtitle":
    "¿Nuevo en el Spreadsheet de USFans? Nuestra guía original y detallada te explica cómo funciona, qué verificar y cómo comprar con confianza.",
  "guide.read": "Leer la guía",

  "articles.title": "Últimas guías y artículos",
  "articles.subtitle":
    "Explora nuestras guías originales y detalladas sobre el Spreadsheet de USFans: QC, envíos, cupones y seguridad.",
  "articles.readMore": "Leer artículo",

  "faq.title": "Preguntas frecuentes",
  "faq.q1": "¿Qué es el Spreadsheet de USFans?",
  "faq.a1":
    "Es un catálogo de productos compartido que organiza los artículos en categorías para que puedas explorar y comparar más fácilmente.",
  "faq.q2": "¿usfanslink.lol está afiliado a USFans?",
  "faq.a2":
    "No. Es un recurso informativo independiente y no está necesariamente afiliado a USFans.",
  "faq.q3": "¿Puedo comprar directamente en este sitio?",
  "faq.a3":
    "No. Este sitio te redirige al sitio principal de USFans, donde puedes ver los detalles y completar tu compra.",
  "faq.q4": "¿Qué idiomas están disponibles?",
  "faq.a4":
    "Inglés, francés, español y polaco están disponibles a través del selector de idioma en el encabezado.",

  "cta.title": "¿Listo para explorar el Spreadsheet?",
  "cta.subtitle":
    "Entra al Spreadsheet de USFans, explora productos por categoría y compara antes de comprar.",

  "safety.title": "Nota de seguridad",
  "safety.text":
    "Verifica siempre los detalles del producto, revisa las fotos de QC cuando estén disponibles y confirma las condiciones de envío antes de comprar. Este sitio solo ofrece información y no vende productos directamente.",
};